/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable react/style-prop-object */
import React, { Component } from "react";
import {
  Container,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  Avatar,
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Alert,
  Chip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { isAuthenticated } from "../auth";
import { Redirect } from "react-router-dom";
import { read, mfa_qr_code, getFullUserList, updateUserRole, findPeople, update, updateUser } from "./apiUser";
import DefaultProfile from "../images/avatar.png";
import DeleteUser from "./DeleteUser";
import FollowProfileButton from "./FollowProfileButton";
import ProfileTabs from "./ProfileTabs";
import { listByUser } from "../post/apiPost";
import { sendMessage } from "../group/apigroup";
import AdminPanel from "../awards/pages/AdminPanel";

class Profile extends Component {
  constructor() {
    super();
    this.state = {
      user: { following: [], followers: [] },
      redirectToSignin: false,
      following: false,
      error: "",
      posts: [],
      qrCode: null,
      userList: [],
      users: [],
      fullUserList: [],
      searchText: '',
      updateMessage: '',
      isEditing: false,
      editForm: { name: '', lastName: '', companyName: '', companyType: '', email: '', about: '' },
      saving: false,
      saveError: '',
      saveSuccess: false,
      confirmEmailOpen: false,
    };
  }

  startEdit = () => {
    const { user } = this.state;
    this.setState({
      isEditing: true,
      saveError: '',
      saveSuccess: false,
      editForm: {
        name: user.name || '',
        lastName: user.lastName || '',
        companyName: user.companyName || '',
        companyType: user.companyType || '',
        email: user.email || '',
        about: user.about || ''
      }
    });
  };

  cancelEdit = () => {
    this.setState({ isEditing: false, saveError: '', saveSuccess: false, confirmEmailOpen: false });
  };

  handleEditChange = field => event => {
    const value = event.target.value;
    this.setState(prev => ({
      editForm: { ...prev.editForm, [field]: value },
      saveError: ''
    }));
  };

  emailChanged = () => {
    const { user, editForm } = this.state;
    return (editForm.email || '').trim().toLowerCase() !== (user.email || '').trim().toLowerCase();
  };

  saveEdit = () => {
    const email = (this.state.editForm.email || '').trim();

    if (email.length === 0) {
      this.setState({ saveError: 'Email is required' });
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this.setState({ saveError: 'Please enter a valid email address' });
      return;
    }

    // The email doubles as the sign-in credential, so confirm before changing it.
    if (this.emailChanged()) {
      this.setState({ confirmEmailOpen: true });
      return;
    }

    this.commitEdit();
  };

  commitEdit = () => {
    const { user, editForm } = this.state;
    const token = isAuthenticated().token;
    this.setState({ saving: true, saveError: '', confirmEmailOpen: false });
    update(user._id, token, { ...editForm, email: (editForm.email || '').trim() }).then(data => {
      if (!data || data.error) {
        this.setState({ saving: false, saveError: (data && data.error) || 'Update failed' });
        return;
      }
      const mergedUser = {
        ...user,
        name: data.name,
        lastName: data.lastName,
        companyName: data.companyName,
        companyType: data.companyType,
        email: data.email,
        about: data.about
      };
      // Refresh the stored profile even for admins: this editor is only shown
      // on your own profile, so a stale email here is your own sign-in address.
      const applyUpdate = () => this.setState({
        user: mergedUser,
        isEditing: false,
        saving: false,
        saveSuccess: true
      });
      updateUser(data, applyUpdate);
    });
  };

  updateUserList = () => {
    getFullUserList(isAuthenticated().token).then(data => {
      if (!data) return;
      this.setState({ ...this.state, userList: data });
    })

  }
  // check follow
  checkFollow = user => {

    const match = user.followers.find(follower => {
      // one id has many other ids (followers) and vice versa
      return follower._id === isAuthenticated().userId;
    });
    return match;
  };



  clickFollowButton = callApi => {
    const userId = isAuthenticated().userId;
    const token = isAuthenticated().token;

    callApi(userId, token, this.state.userId).then(data => {
      if (data.error) {
        this.setState({ error: data.error });
      } else {
        this.setState({ user: data, following: !this.state.following });
      }
    });
  };

  init = userId => {
    const token = isAuthenticated().token;
    read(userId, token).then(data => {
      if (!data) {
        console.log("Failed to fetch user data");
        return;
      }
      if (data.error) {
        this.setState({ redirectToSignin: true });
      } else {
        let following = this.checkFollow(data);
        this.setState({ user: data, following });
        this.loadPosts(data._id);
      }
    });
    this.setState({ profileimage: `` })
  };

  loadPosts = userId => {
    const token = isAuthenticated().token;
    listByUser(userId, token).then(data => {
      if (!data) return;
      if (data.error) {
        console.log(data.error);
      } else {
        this.setState({ posts: data });
      }
    });
  };

  componentDidMount() {
    const userId = this.props.match.params.userId;
    this.init(userId);
    this.generateQrCode();
    this.updateUserList()
  }


  generateQrCode() {
    mfa_qr_code().then(data => {
      if (!data) return;
      if (data.error) {
        console.log(data.error);
      } else {
        console.log('qrcode', data)
        this.setState({ qrCode: data });
      }
    });
  };

  // changes user status to approved and sends email
  approveUser = (userId, email, firstName) => {
    updateUserRole(userId, 'member', isAuthenticated().token).then(approved => {
      // console.log('approveUser response:', approved);

      // Bail out if the backend rejected the request so we don't email the
      // user or flag success on a failed approval.
      if (!approved || approved.error) {
        this.setState({
          ...this.state,
          updateMessage: (approved && approved.error) || 'Failed to approve user.'
        });
        return;
      }

      const mailMessage = {
        "subject": "SDSIC Membership request",
        "from": "donotreply@sdsconsortium.com",
        "to": email,
        "text": `Your SDSIC Membership has been approved with email: ${email} and you can now login to our site.`,
        "html": `<html><body><p>Your SDSIC Membership has been approved with email: ${email} and you can now login to our site.</p></body></html>`
      }

      // make request to api to send message. The approval itself has already
      // succeeded, so a failed email is reported without undoing it.
      sendMessage(mailMessage).then(sent => {
        this.updateUserList()
        this.setState({
          ...this.state,
          updateMessage: (!sent || sent.error)
            ? `${approved.message} (but the approval email to ${email} could not be sent)`
            : approved.message
        });
      });

    })
  }


  componentWillReceiveProps(props) {
    const userId = props.match.params.userId;
    this.init(userId);

  }

  handleChange = name => event => {

    const input = event.target;
    const value = event.target.type === 'checkbox' ? input.checked : input.value;

    this.setState({
      ...this.state,
      error: "",
      [name]: value
    });

  };

  holdUser = (userId) => {
    updateUserRole(userId, 'pending', isAuthenticated().token).then(approved => {
      console.log(approved)
      this.setState({
        ...this.state,
        updateMessage: approved.message
      });
      this.updateUserList()
    })
  }


  renderUsers = users => (
    <Grid container spacing={3}>
      {users.map((user, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Card
            elevation={2}
            sx={{
              height: '100%',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 16px rgba(0, 62, 126, 0.15)',
              }
            }}
          >
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ color: '#003E7E', fontWeight: 600 }}>
                {user.name} {user.lastName}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {user.companyName}
              </Typography>
              <Chip
                label={user.role}
                size="small"
                sx={{
                  backgroundColor: 'rgba(0, 62, 126, 0.1)',
                  color: '#003E7E',
                  fontWeight: 600,
                  mb: 2
                }}
              />

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => { this.holdUser(user._id) }}
                  fullWidth
                  startIcon={<PauseCircleIcon />}
                  sx={{
                    borderColor: '#FF6600',
                    color: '#FF6600',
                    '&:hover': {
                      borderColor: '#e55a00',
                      backgroundColor: 'rgba(255, 102, 0, 0.05)',
                    }
                  }}
                >
                  Put on Hold
                </Button>

                {this.makeVendor && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => { this.makeVendor(user._id, user.email, user.name) }}
                    fullWidth
                    startIcon={<CheckCircleIcon />}
                    sx={{
                      borderColor: '#003E7E',
                      color: '#003E7E',
                      '&:hover': {
                        borderColor: '#003E7E',
                        backgroundColor: 'rgba(0, 62, 126, 0.05)',
                      }
                    }}
                  >
                    Make Vendor
                  </Button>
                )}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );


  clickSearch = () => {
    findPeople(isAuthenticated().userId, this.state.searchText, isAuthenticated().token).then(data => {
      if (!data) return;
      if (data.error) {
        console.log(data.error);
      } else {
        this.setState({
          ...this.state,
          users: data
        });
      }
    });
  };



  render() {
    const { redirectToSignin, user, posts } = this.state;
    if (redirectToSignin) return <Redirect to="/signin" />;

    const photoUrl = user._id
      ? user.linkedInPhoto
      : DefaultProfile;

    return (
      <>
        {/* Hero Section */}
        <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 4, mb: 4 }}>
          <Container maxWidth="lg">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <PersonIcon sx={{ fontSize: 48 }} />
              <Box>
                <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 0.5 }}>
                  {user.name}'s Profile
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.9 }}>
                  {user.companyName || 'SDSIC Member'}
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>

        <Container maxWidth="lg" sx={{ mb: 6 }}>
          {/* Profile Card */}
          <Card elevation={3} sx={{ mb: 4, borderRadius: 3, overflow: 'visible' }}>
            <CardContent sx={{ p: 4 }}>
              <Grid container spacing={4}>
                {/* Profile Photo */}
                <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
                  <Avatar
                    src={photoUrl}
                    alt={user.name}
                    sx={{
                      width: 200,
                      height: 200,
                      margin: '0 auto',
                      border: '4px solid #003E7E',
                      boxShadow: '0 4px 12px rgba(0, 62, 126, 0.2)'
                    }}
                    imgProps={{
                      onError: (i) => (i.target.src = `${DefaultProfile}`)
                    }}
                  />

                  {/* Action Buttons */}
                  {isAuthenticated().userId === user._id ? (
                    <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
                      {!this.state.isEditing ? (
                        <Button
                          onClick={this.startEdit}
                          variant="contained"
                          startIcon={<EditIcon />}
                          fullWidth
                          sx={{
                            backgroundColor: '#003E7E',
                            '&:hover': { backgroundColor: '#FF6600' }
                          }}
                        >
                          Edit Profile
                        </Button>
                      ) : (
                        <>
                          <Button
                            onClick={this.saveEdit}
                            variant="contained"
                            disabled={this.state.saving}
                            startIcon={this.state.saving ? <CircularProgress size={18} color="inherit" /> : <SaveIcon />}
                            fullWidth
                            sx={{
                              backgroundColor: '#4caf50',
                              '&:hover': { backgroundColor: '#45a049' }
                            }}
                          >
                            {this.state.saving ? 'Saving…' : 'Save Changes'}
                          </Button>
                          <Button
                            onClick={this.cancelEdit}
                            variant="outlined"
                            disabled={this.state.saving}
                            startIcon={<CancelIcon />}
                            fullWidth
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                      <DeleteUser userId={user._id} />
                    </Box>
                  ) : (
                    <Box sx={{ mt: 3 }}>
                      <FollowProfileButton
                        following={this.state.following}
                        onButtonClick={this.clickFollowButton}
                      />
                    </Box>
                  )}

                  <Dialog
                    open={this.state.confirmEmailOpen}
                    onClose={() => this.setState({ confirmEmailOpen: false })}
                  >
                    <DialogTitle>Change your sign-in email?</DialogTitle>
                    <DialogContent>
                      <DialogContentText component="div">
                        <Box sx={{ mb: 2 }}>
                          Your email will change from <strong>{user.email}</strong> to{' '}
                          <strong>{(this.state.editForm.email || '').trim()}</strong>.
                        </Box>
                        <Box>
                          You will sign in with the new address from now on, and password
                          resets will be sent there. Make sure you can receive mail at it.
                        </Box>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                      <Button onClick={() => this.setState({ confirmEmailOpen: false })}>
                        Cancel
                      </Button>
                      <Button onClick={this.commitEdit} variant="contained" color="primary">
                        Change email
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>

                {/* Profile Info */}
                <Grid item xs={12} md={8}>
                  {this.state.saveSuccess && !this.state.isEditing && (
                    <Alert severity="success" sx={{ mb: 2 }} onClose={() => this.setState({ saveSuccess: false })}>
                      Profile updated successfully.
                    </Alert>
                  )}
                  {this.state.saveError && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {this.state.saveError}
                    </Alert>
                  )}

                  {this.state.isEditing ? (
                    <Box>
                      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#003E7E' }}>
                        Edit Your Profile
                      </Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="First Name"
                            value={this.state.editForm.name}
                            onChange={this.handleEditChange('name')}
                            disabled={this.state.saving}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Last Name"
                            value={this.state.editForm.lastName}
                            onChange={this.handleEditChange('lastName')}
                            disabled={this.state.saving}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Company Name"
                            value={this.state.editForm.companyName}
                            onChange={this.handleEditChange('companyName')}
                            disabled={this.state.saving}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl fullWidth disabled={this.state.saving}>
                            <InputLabel>Company Type</InputLabel>
                            <Select
                              value={this.state.editForm.companyType}
                              onChange={this.handleEditChange('companyType')}
                              label="Company Type"
                            >
                              <MenuItem value=""><em>-- Select company type --</em></MenuItem>
                              <MenuItem value="Utility">Utility Company</MenuItem>
                              <MenuItem value="Services">Engineering Services Provider</MenuItem>
                              <MenuItem value="Vendor">Vendor</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="Email"
                            type="email"
                            value={this.state.editForm.email}
                            onChange={this.handleEditChange('email')}
                            disabled={this.state.saving}
                            helperText={
                              this.emailChanged()
                                ? 'This is the address you sign in with - you will need the new one next time you log in.'
                                : 'The address you sign in with, and where committee mail is sent.'
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="About"
                            multiline
                            rows={4}
                            value={this.state.editForm.about}
                            onChange={this.handleEditChange('about')}
                            disabled={this.state.saving}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  ) : (
                    <>
                      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3, color: '#003E7E' }}>
                        {user.name} {user.lastName}
                      </Typography>

                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {user.companyName && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <BusinessIcon sx={{ color: '#003E7E', fontSize: 28 }} />
                            <Box>
                              <Typography variant="caption" color="text.secondary" display="block">
                                Company
                              </Typography>
                              <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                {user.companyName}
                              </Typography>
                            </Box>
                          </Box>
                        )}

                        {user.companyType && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <BusinessIcon sx={{ color: '#003E7E', fontSize: 28 }} />
                            <Box>
                              <Typography variant="caption" color="text.secondary" display="block">
                                Company Type
                              </Typography>
                              <Chip
                                label={user.companyType}
                                sx={{
                                  backgroundColor: 'rgba(0, 62, 126, 0.1)',
                                  color: '#003E7E',
                                  fontWeight: 600
                                }}
                              />
                            </Box>
                          </Box>
                        )}

                        {user.email && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <EmailIcon sx={{ color: '#003E7E', fontSize: 28 }} />
                            <Box>
                              <Typography variant="caption" color="text.secondary" display="block">
                                Email
                              </Typography>
                              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                {user.email}
                              </Typography>
                            </Box>
                          </Box>
                        )}

                        {user.created && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <CalendarMonthIcon sx={{ color: '#003E7E', fontSize: 28 }} />
                            <Box>
                              <Typography variant="caption" color="text.secondary" display="block">
                                Member Since
                              </Typography>
                              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                {new Date(user.created).toDateString()}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </Box>

                      {/* About Me */}
                      {user.about && (
                        <Box sx={{ mt: 4, p: 3, backgroundColor: 'rgba(0, 62, 126, 0.02)', borderRadius: 2 }}>
                          <Typography variant="h6" sx={{ mb: 1, color: '#003E7E', fontWeight: 600 }}>
                            About Me
                          </Typography>
                          <Typography variant="body1" color="text.secondary">
                            {user.about}
                          </Typography>
                        </Box>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Profile Tabs */}
          <ProfileTabs
            followers={user.followers}
            following={user.following}
            posts={posts}
          />

          {/* Admin Section */}
          {(isAuthenticated().email === "trevor.scullion@automationforce.com") && (
            <Box sx={{ mt: 4 }}>
              <Paper elevation={2} sx={{ p: 3, borderRadius: 3, mb: 3, backgroundColor: 'rgba(0, 62, 126, 0.02)' }}>
                <Typography variant="h5" sx={{ mb: 3, color: '#003E7E', fontWeight: 600 }}>
                  Admin: User Management
                </Typography>

                {this.state.updateMessage === 'User Updated Successfully' && (
                  <Alert severity="success" sx={{ mb: 3 }}>
                    User was approved successfully!
                  </Alert>
                )}

                {(this.state.userList.length > 0) && (
                  <Box>
                    <Typography variant="h6" gutterBottom sx={{ color: '#003E7E', mb: 2 }}>
                      Pending Approvals ({this.state.userList.length})
                    </Typography>
                    <TableContainer component={Paper} elevation={1}>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: '#003E7E' }}>
                            <TableCell sx={{ color: 'white', fontWeight: 600 }}>First Name</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 600 }}>Last Name</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 600 }}>Email</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 600 }}>Current Role</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 600 }} align="center">Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.userList.map((user, pIndex) => (
                            <TableRow key={pIndex} hover>
                              <TableCell>{user.name}</TableCell>
                              <TableCell>{user.lastName}</TableCell>
                              <TableCell>{user.email}</TableCell>
                              <TableCell>
                                <Chip
                                  label={user.role}
                                  size="small"
                                  sx={{
                                    backgroundColor: user.role === 'pending' ? 'rgba(255, 152, 0, 0.1)' : 'rgba(76, 175, 80, 0.1)',
                                    color: user.role === 'pending' ? '#f57c00' : '#388e3c',
                                    fontWeight: 600
                                  }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => { this.approveUser(user._id, user.email, user.name) }}
                                  startIcon={<CheckCircleIcon />}
                                  sx={{
                                    backgroundColor: '#4caf50',
                                    '&:hover': {
                                      backgroundColor: '#45a049',
                                    }
                                  }}
                                >
                                  Approve
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}

                {this.state.userList.length === 0 && (
                  <Alert severity="success" icon={<CheckCircleIcon />}>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      All caught up! No users waiting for approval.
                    </Typography>
                  </Alert>
                )}

              </Paper>

              {/* Find Users Section */}
              <Paper elevation={2} sx={{ p: 3, borderRadius: 3, mt: 3, backgroundColor: 'rgba(0, 62, 126, 0.02)' }}>
                <Typography variant="h5" sx={{ mb: 3, color: '#003E7E', fontWeight: 600 }}>
                  Find Any Existing User
                </Typography>

                <TextField
                  fullWidth
                  label="Search by first name"
                  name="searchText"
                  placeholder="Enter first name (case-sensitive)"
                  value={this.state.searchText}
                  onChange={this.handleChange("searchText")}
                  margin="normal"
                  variant="outlined"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: '#003E7E',
                      },
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: '#003E7E',
                    },
                  }}
                />

                <Button
                  variant="contained"
                  onClick={this.clickSearch}
                  sx={{
                    mt: 2,
                    mb: 3,
                    backgroundColor: '#003E7E',
                    '&:hover': {
                      backgroundColor: '#FF6600',
                    }
                  }}
                >
                  Search
                </Button>

                {this.state.users.length > 0 && this.renderUsers(this.state.users)}
              </Paper>

              {/* Digital Awards Admin */}
              <Box sx={{ mt: 4 }}>
                <AdminPanel />
              </Box>
            </Box>
          )}
        </Container>
      </>
    );
  }
}

export default Profile;